/* eslint-disable @typescript-eslint/no-explicit-any */
import { replaceDoubleSlashWithSingleSlash } from "@enfusion-ui/utils";
import { AUTH_CHANNEL } from "../context";
import { AUTH_CONFLICT, AUTH_LOGOUT } from "../context/auth/AuthProvider";
export async function restServerBase(endpoint, params) {
    const headers = {
        "X-Requested-With": "XMLHttpRequest",
        ...params?.headers,
    };
    let body = params?.body;
    if (!(params?.body instanceof FormData)) {
        headers["Content-Type"] = "text/plain";
        if (typeof params?.body === "object") {
            headers["Content-Type"] = "application/json";
            body = JSON.stringify(body);
        }
    }
    const config = {
        method: params?.body ? "POST" : "GET",
        ...params,
        body,
        headers,
    };
    const REQ_URL = `${process.env.REACT_APP_PROXY_HOST || ""}${replaceDoubleSlashWithSingleSlash(`${endpoint.startsWith("/") ? "" : "/"}${endpoint}`)}`;
    console.info(`[REST] ${config.method} ${REQ_URL}`);
    const response = await window.fetch(REQ_URL, config);
    if (response.status === 418) {
        console.info(`[REST]: auth conflict (${response.status}): ${endpoint}`);
        if (params?.ignoreAuth !== true) {
            AUTH_CHANNEL.broadcastMessage(AUTH_CONFLICT);
        }
        throw new Error("Conflict");
    }
    if (response.status === 503) {
        console.info(`[REST]: server issue (${response.status}): ${endpoint}`);
        throw new Error("Service Not Available");
    }
    if (response.status === 401 || response.status === 403) {
        console.info(`[REST]: auth error (${response.status}): ${endpoint}`);
        if (params?.ignoreAuth !== true)
            AUTH_CHANNEL.broadcastMessage(AUTH_LOGOUT);
        throw new Error("Unauthorized");
    }
    if (response.headers.get("Content-Type")?.startsWith("application/json")) {
        const json = (await response.json());
        return response.ok ? [json, response] : Promise.reject(json);
    }
    return [(await response.text()), response];
}
export async function restServer(endpoint, params) {
    const res = await restServerBase(endpoint, params);
    return res[0];
}
export function restServerAbortable(endpoint, autoAbort) {
    const abortable = async function (params) {
        if (autoAbort)
            abortable.abortController.abort();
        const signal = abortable.abortController.signal;
        const res = await restServerBase(endpoint, { signal, ...params });
        return res[0];
    };
    abortable.abortController = new AbortController();
    return abortable;
}
